import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRocket20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRocket20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.093 4.124c.725-.725 1.713-1.11 2.807-1.271 1.092-.16 2.18-.079 2.953.035.03.005.044.015.051.022s.018.02.022.051c.114.773.196 1.861.036 2.954-.161 1.093-.547 2.081-1.271 2.806-1.79 1.79-3.702 3.029-5.17 3.82-.62.333-1.156.585-1.564.762L6.51 10.858c.178-.409.43-.945.763-1.565.79-1.468 2.029-3.379 3.82-5.17m5.659 5.658a23 23 0 0 1-2.13 1.875v2.924a.75.75 0 0 1-.343.63l-4.735 3.053c-.965.622-2.187-.276-1.882-1.383l.594-2.157-3.165-3.165-2.158.594c-1.106.305-2.004-.918-1.382-1.882l3.052-4.735a.75.75 0 0 1 .63-.344h2.88q.023 0 .044.002a23 23 0 0 1 1.876-2.131c2.054-2.054 5.33-1.91 7.038-1.659a1.574 1.574 0 0 1 1.34 1.34c.25 1.708.395 4.983-1.66 7.038M9.823 14.56a24 24 0 0 0 3.3-1.83v1.442l-3.841 2.476.514-1.868a.8.8 0 0 0 .027-.22m-2.74-7.868h-1.44l-2.477 3.841 1.869-.514a.8.8 0 0 1 .22-.027 24 24 0 0 1 1.828-3.3m5.83.21a1.357 1.357 0 1 0 1.919-1.92 1.357 1.357 0 0 0-1.92 1.92"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRocket20);
